module.exports = __webpack_public_path__ + "e027a0cfb520732ec63654502bbccd46.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/FR.svg
// module id = XFmu
// module chunks = 0